import { type JSX } from 'react';
import { Button, ICON_COLOR, IconButton } from '@zep-us/zus';
import { ChevronLeftIcon, XSmallIcon } from '@zep-us/zus-icons';
type CoachmarkBubbleProps = {
  imageSrc: string;
  description: string;
  closeAriaLabel: string;
  backAriaLabel: string;
  showBack: boolean;
  stepLabel: string;
  primaryLabel: string;
  primaryRightIcon?: JSX.Element;
  onPrimaryClick: VoidFunction;
  onBack: VoidFunction;
  onClose: VoidFunction;
};
export const CoachmarkBubble = ({
  imageSrc,
  description,
  closeAriaLabel,
  backAriaLabel,
  showBack,
  stepLabel,
  primaryLabel,
  primaryRightIcon,
  onPrimaryClick,
  onBack,
  onClose
}: CoachmarkBubbleProps) => {
  const normalizedDescription = description.replace(/<br\s*\/?>\s*/gi, '\n');
  return <div className="w-[275px] overflow-hidden rounded-md bg-default pb-md text-default shadow-lg" onClick={event => event.stopPropagation()} data-sentry-component="CoachmarkBubble" data-sentry-source-file="CoachmarkBubble.tsx">
      <div className="flex justify-end px-sm pt-2xs">
        <button type="button" className="flex size-[20px] shrink-0 items-center justify-center rounded-2xs hover:bg-opacity-black-1" aria-label={closeAriaLabel} onClick={onClose}>
          <XSmallIcon size="sm" fill={ICON_COLOR.neutral} data-sentry-element="XSmallIcon" data-sentry-source-file="CoachmarkBubble.tsx" />
        </button>
      </div>

      <img className="block aspect-[550/330] w-full object-cover p-px" src={imageSrc} alt="" />

      <div className="flex flex-col gap-sm px-sm pt-xs">
        <p className="whitespace-pre-line text-body-md-semibold text-neutral">
          {normalizedDescription}
        </p>
        <div className="flex items-center justify-between">
          <span className="px-2 text-caption-md-semibold text-assistive">
            {stepLabel}
          </span>
          <div className="flex items-center justify-end gap-xs">
            {showBack && <IconButton type="button" size="xs" intent="neutral" className="size-[28px]" aria-label={backAriaLabel} onClick={onBack}>
                <ChevronLeftIcon size="xs" fill={ICON_COLOR.neutral} />
              </IconButton>}
            <Button type="button" size="xs" intent="strong" className="h-[28px] w-auto" rightSlot={primaryRightIcon} onClick={onPrimaryClick} data-sentry-element="Button" data-sentry-source-file="CoachmarkBubble.tsx">
              {primaryLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>;
};